import { filter } from 'rxjs/operators';
import { Component, input, output } from '@angular/core';
import { Observable } from 'rxjs';
import { Profile } from '../../profile/store/profile.entity';
import { ProfileService } from '../../profile/providers/profile.service';
import { BrandingService } from '../../branding/providers/branding.service';
import { BrandingState } from '../../branding/store/branding.state';


@Component({
    selector: 'app-popup-container',
    templateUrl: './popup-container.component.html',
    styleUrls: ['./popup-container.component.scss'],
    imports: []
})
export class PopupContainerComponent {
    readonly title = input<string>(undefined);
    readonly icon = input<string>(undefined);
    readonly showCloseButton = input(true);
    readonly closeClicked = output<void>();

    profileData$: Observable<Profile>;
    public brandingData$: Observable<BrandingState>;

    constructor(private profileService: ProfileService, private brandingService: BrandingService) {
        this.profileData$ = this.profileService.getCurrentProfileDataObserver();
        this.brandingData$ = this.brandingService.getBrandingSettingsFromStore().pipe(filter(e => e !== null && e !== undefined));
    }

    closePopup() {
        this.closeClicked.emit();
    }
}
